import cx from 'clsx';

import styles from 'theme/components/page-description.module.scss';

const PageDescription = ({ children, className, ...props }) => (
  <p {...props} className={cx(className, styles.description)}>
    {children}
  </p>
);

export default PageDescription;
